import { Action } from 'redux';
import _ from 'underscore';

import { isSitesAndTenantsInfoRequestSucceededAction } from '../actions/SitesAndTenantsInfoRequestAction';
import { ISitesAndTenantsInfo } from '../serverApi/types/ISitesAndTenantsInfo';

const InitialState: ISitesAndTenantsInfo = {
    sitesInfo: [],
    managedTenants: []
};

export function sitesAndTenantsInfoReducer(
  previousState: ISitesAndTenantsInfo = InitialState,
  action: Action
): ISitesAndTenantsInfo {
  if (isSitesAndTenantsInfoRequestSucceededAction(action)) {
    if (action.sitesAndTenantsInfo && !_.isEqual(action.sitesAndTenantsInfo, previousState)) {
      return action.sitesAndTenantsInfo;
    }
  }

  return previousState;
}
